export const home =  {

    "heading1_hero_section" : "STRENGTHEN YOUR HOUSE TO",

    "heading2_hero_section" : "Weather the Storm",

    "heading3_hero_section" : "Strengthen the key connections of your house to withstand severe weather",


    "heading1_intro_section" : "RETROFITTING YOUR HOUSE",

    "heading2_intro_section" : "LEVELS OF MAINTENANCE AND RETROFITTING",
    "text1_intro_section" : " Cyclones and thunderstorms are part of life in Australia. The levels of  maintenance and retrofitting below make your house safer in a wind storm. " +
    "Select a level starting from simple maintenance (Level 1) to roof tie-down upgrades (Level 3). " +
    "For Level 3 select the features of your house to get customised retrofitting guidelines. ",

    "text2_intro_section" : "Use the resources below to learn more about why you should retrofit, " +
    "how winds affect houses, and getting approvals to carry out retrofits.",


    "heading_middle_section" : "Why Retrofit?",

    "text_middle_section" : "Houses are where we shelter during a cyclone or storm. " +
    "They must be up to the task of keeping us safe. " +
    "Retrofitting a house by strengthening key connections can greatly improve its performance in a windstorm. " +
    "<br>" +
    "Older houses are more vulnerable to windstorms and can benefit from retrofitting. " +
    "However, newer houses can also benefit from maintenance and window and door protection to reduce water damage. " +
    "",

    "heading_end_section" : "BACKED BY RESEARCH",

    "text1_end_section" : "The following graph shows how different levels of maintenance and retrofitting can protect an older (pre-1980s) house from damage at different wind speeds. " +
    "The effectiveness of retrofitting has been quantified using detailed vulnerability modelling using wind tunnel testing, structural analysis and statistical analysis.",


    "heading_resources_section" : "RESOURCES",

    "heading_examples_section" : "EXAMPLES OF WIND DAMAGE",

    "heading_video_section" : "VIDEOS",

}